import ReactEcharts from "echarts-for-react";
import { useRef } from "react";

import * as echarts from "echarts";
export default function DcPower({ title, id }) {
  const echarts_react_1 = useRef();
  const option = {
    color: ['#008000', '#FFC300'],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985'
        }
      }
    },
    legend: {
      data: ['Dc Power', 'Max.Threshold']
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        boundaryGap: false,
        data: [
          '00:00 AM 31 May, 25',
          '01:00 AM 31 May, 25',
          '02:00 AM 31 May, 25',
          '03:00 AM 31 May, 25',
          '04:00 AM 31 May, 25',
          '05:00 AM 31 May, 25',
          '06:00 AM 31 May, 25',
          '07:00 AM 31 May, 25',
          '08:00 AM 31 May, 25',
          '09:00 AM 31 May, 25',
          '10:00 AM 31 May, 25',
          '11:00 AM 31 May, 25',
          '12:00 PM 31 May, 25',
          '13:00 PM 31 May, 25',
          '14:00 PM 31 May, 25',
          '15:00 PM 31 May, 25',
          '16:00 PM 31 May, 25'
        ],
        axisLabel: {
          formatter: function (value, index) {
            // Split the value by spaces to get time and date parts
            var parts = value.split(' ');
            var time = parts[0] + ' ' + parts[1]; // e.g., "00:00 AM"
            var date = parts[2] + ' ' + parts[3]; // e.g., "01 Jul, 24"

            // Only show the time label at intervals (e.g., every 12 hours)
            if (index % 24 === 0) {
              // return time + '\n' + date;
              return date;
            }
            return '';
          },
          fontSize: 10,
          rotate: 0,
          interval: 0,
          align: 'left'
        }
      }
    ],
    yAxis: [
      {
        name: 'Dc Power',
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: {
          fontWeight: 'bold',
          color: '#000000'
        },
        type: 'value',
        axisLine: {
          lineStyle: {
            color: '#000'
          }
        },
        splitLine: {
          lineStyle: {
            color: '#ddd'
          }
        },
        axisLabel: {
          formatter: '{value} kW'
        },
        axisPointer: {
          snap: true
        }
      }
    ],
    series: [
      {
        name: 'Dc Power',
        type: 'line',
        symbol: 'none',
        sampling: 'lttb',
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(51, 176, 16,0.8)'
            },
            {
              offset: 1,
              color: 'rgba(10, 247, 73,0.3)'
            }
          ])
        },
        emphasis: {
          focus: 'series'
        },
        lineStyle: {
          color: 'rgba(51, 176, 16,1)'
        },
        data: [
          '0.07',
          '0.06',
          '0.06',
          '0.05',
          '0.05',
          '0.05',
          '0.05',
          '0.06',
          '0.07',
          '0.07',
          '0.07',
          '0.07',
          '0.07',
          '0.08',
          '0.07',
          '0.06',
          '0.07'
        ]
      },
      {
        name: 'Max.Threshold',
        type: 'line',
        symbol: 'none',
        sampling: 'lttb',
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(250, 218, 57,0.8)'
            },
            {
              offset: 1,
              color: 'rgba(58,77,233,0.3)'
            }
          ])
        },
        emphasis: {
          focus: 'series'
        },
        lineStyle: {
          color: 'rgba(250, 218, 57,1)'
        },
        data: [
          '0.08',
          '0.08',
          '0.06',
          '0.06',
          '0.05',
          '0.05',
          '0.07',
          '0.07',
          '0.08',
          '0.08',
          '0.08',
          '0.08',
          '0.08',
          '0.09',
          '0.09',
          '0.07',
          '0.08'
        ]
      }
    ]
  };

  return (
    <>
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5>BGKCH2 (BL) <i className="fa-solid fa-search"></i></h5>
          <div className="d-flex gap-2">
            <select className="form-select form-select-sm" >
              <option>Today</option>
              <option>Date Range</option>
            </select>
            <div class="dropdown">
              <button type="button" class="btn btn-info dropdown-toggle" data-bs-toggle="dropdown">
                Export
              </button>
              <ul class="dropdown-menu">
                <li><a class="dropdown-item" href="#">CSV</a></li>
                <li><a class="dropdown-item" href="#">XLSX</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="card-body p-0 m-0">
          <ReactEcharts ref={echarts_react_1} style={{ height: "300px" }} option={option} />

        </div>
      </div>
    </>
  );
}